// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"2":"75851199","19":"d8edd23c","186":"818c4155","235":"f6d367bc","372":"d3661b0b","390":"07105793","655":"6ec85b6f","777":"cebb2fee","807":"66252371"}[chunkId] + ".js";
};